
<!-- lista de requisiciones pendientes -->

<div class="titulo" style="margin: 0 auto;text-align: center;width: 75%;" >

    <h4>Requisiciones Pendientes</h4>

</div>

<div class="mt-5" style="width: 90%;margin: 0 auto;" >

    <table id="requisiciones" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger" class="table" style="width: 100%;">
      
        <thead>
            <tr style="color:#000">
                    <!-- <th style="text-align:center;">Id</th> -->
                <th style="text-align:center;width: 50px;">Folio</th>
                  <th style="text-align:center;">Plantel</th>
                <th style="text-align:center;">Fecha</th>
                <th style="text-align:center;width: 160px;">Archivo petición</th>
                   <th style="text-align:center;width: 165px;">Archivo Finalización</th>
                <th style="text-align:center;width: 180px;">Estatus</th> 
                 <th style="text-align:center;">Comentario Plantel</th>
                 <th style="text-align:center;">Comentario DG</th>
            </tr>
        </thead>
        <tbody style="font-size: 15px;">
            <tr *ngFor="let req of req_pendientes">
                 <!-- <td style="text-align:center;">{{req.id}}</td> -->
                <td style="text-align:center;">{{req.folio_solicitud}}</td>
                 <td style="text-align:center;">{{req.plantel}}</td>
                <td style="text-align:center;">{{req.fecha_solicitud | date: 'dd/MM/yyyy'}}</td>
                <td style="text-align:center;">

                     <input *ngIf="req.con_url && permiso2" id="file" type="file" style="width: 110px;" (change)="upload($event)" class=" btn btn-primary form-control" multiple="multiple" accept=".pdf" required>
                     <button *ngIf="req.con_url && permiso2" class="btn btn-warning" style="margin:4px;" (click)="subirPDF(req.id,req.folio_solicitud)"><i class="mdi mdi-cloud-upload"></i></button>
                     <button *ngIf="req.sin_url" class="btn btn-light" style="margin:4px;" (click)="abrirPDF(req.ruta)"><i class="mdi mdi-file-pdf fa-1x" style="color: rgb(223, 21, 21);"></i></button>
                
                </td>
                 <td style="text-align:center;">

                     <input *ngIf="req.con_url_dg && permiso" id="miArchivo" type="file" style="width: 110px;" (change)="uploadDG($event)" class=" btn btn-primary form-control" multiple="multiple" accept=".pdf" required>
                     <button *ngIf="req.con_url_dg && permiso" class="btn btn-warning" style="margin:4px;" (click)="subirPDFDG(req.id,req.folio_solicitud,req.id_centrotrabajo_solicitante)"><i class="mdi mdi-cloud-upload"></i></button>
                     <button *ngIf="req.sin_url_dg" class="btn btn-light" style="margin:4px;" (click)="abrirPDFDG(req.ruta_dg)"><i class="mdi mdi-file-pdf fa-1x" style="color: rgb(223, 21, 21);"></i></button>
                
                </td>
                <!-- <td id="Texto" [ngStyle]="{'color':req.status=='Enviado a DG' ? 'orange' : 'red'}">{{req.status}}</td>  -->
                  <td id="Texto" [ngStyle]="{'color':req.status=='Enviado a Almacén General' ? '#F57627' : req.status=='Pendiente' ? 'red' : 'green', 'font-weight':'bolder','text-align':'center'}">{{req.status}}</td>        
                  
                  <td style="text-align:center;max-width: 10%;">
                    <button *ngIf="req.status=='Proceso Terminado' && BotonComentarioPlantel && mostrarBotonsegunFecha" class="btn btn-light" data-toggle="modal" data-target="#exampleModal" (click)="obtenerIdParaComentario(req.folio_solicitud,req.id_centrotrabajo_solicitante)" title="Agregar un comentario" style="margin:4px;"><i class="mdi mdi-comment" style="color: gray;"></i></button>
                    {{req.comentario_plantel}}
                  </td>

                  <td style="text-align:center;">
                    <button *ngIf="req.status=='Proceso Terminado' && BotonComentarioDg" class="btn btn-light" data-toggle="modal" data-target="#exampleModal" (click)="obtenerIdParaComentario(req.folio_solicitud,req.id_centrotrabajo_solicitante)" title="Agregar un comentario" style="margin:4px;"><i class="mdi mdi-comment"  style="color: gray;"></i></button>
                    {{req.comentario_dg}}
                </td>
            </tr>
        </tbody>
    </table>
</div>







<!-- Modal -->
<div class="modal fade" id="exampleModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h5 class="modal-title" id="exampleModalLabel">Agregar comentario</h5>
        <button type="button" class="close" data-dismiss="modal" aria-label="Close">
          <span aria-hidden="true">&times;</span>
        </button>
      </div>
      <div class="modal-body">


            <form (ngSubmit)="AgregarComentario(f)" #f="ngForm">
                
                <div class="row">
                    <div class="col-12">

                     <label for="exampleFormControlTextarea1">Escriba su comentario (200 caracteres)</label>
                    <textarea [(ngModel)]="comentario.comentario" name="comentario" class="form-control" id="exampleFormControlTextarea1" required rows="3" maxlength="200"></textarea>
                    </div>
                </div>
                <br>
                      <button type="submit" class="btn btn-primary">Enviar</button>

            </form>

      </div>
      <div class="modal-footer">
  
      </div>
    </div>
  </div>
</div>
